import { render } from "./TournamentLiveScoringHH.vue?vue&type=template&id=3e0df14c&scoped=true"
import script from "./TournamentLiveScoringHH.vue?vue&type=script&lang=js"
export * from "./TournamentLiveScoringHH.vue?vue&type=script&lang=js"

import "./TournamentLiveScoringHH.vue?vue&type=style&index=0&id=3e0df14c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0df14c"]])

export default __exports__